/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "@material-ui/core/Icon";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
// import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from "@material-ui/icons/ExpandMore";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import Collapse from "@material-ui/core/Collapse";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import BusinessIcon from "@material-ui/icons/Business";
import Home from "@material-ui/icons/House";
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { TrainRounded } from "@material-ui/icons";
import StarBorder from "@material-ui/icons/StarBorder";
import Notifications from "@material-ui/icons/Notifications";
import AssessmentIcon from "@material-ui/icons/Assessment";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import NotificationsIcon from "@material-ui/icons/Notifications";
import simplyIO from "assets/img/simply-io.jpg";
import EnergySavingsLeafIcon from '@material-ui/icons/Eco';
import DescriptionIcon from '@material-ui/icons/Description';

const drawerWidth = 245;
const useStyles = makeStyles(styles);
const useStyles1 = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
}));

export default function Sidebar(props) {
  const role_id = localStorage.getItem("roleID");
  const classes = useStyles();
  const classes1 = useStyles1();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [AlOpen, setAlOpen] = React.useState(false);
  const [rou, setRou] = React.useState([]);
  const [controlOpen, setControlOpen] = React.useState(false);
  const [controlOpen1, setControlOpen1] = React.useState(false);
  const [controlOpen2, setControlOpen2] = React.useState(false);
  const [controlOpen3, setControlOpen3] = React.useState(false);
  const [controlOpen4, setControlOpen4] = React.useState(false);
  const [controlOpen5, setControlOpen5] = React.useState(false);
  const [spaceOpen, setSpaceOpen] = React.useState(false);
  const [reportOpen, setReportOpen] = React.useState(false);
  const [schOpen, setSchOpen] = React.useState(false);
  const [analytics, setAnalytics] = React.useState(false);
  const [instruments, setInstruments] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  const handleClickAl = () => {
    setAlOpen(!AlOpen);
  };
  const closeSubControls = () => {
    setControlOpen1(false);
    setControlOpen2(false);
    setControlOpen3(false);
    setControlOpen4(false);
    setControlOpen5(false);
  };
  const closeControlDropdown = () => {
    setControlOpen(false);
    closeSubControls();
  };
  const handleControl = () => {
    const next = !controlOpen;
    if (!next) closeSubControls();
    setControlOpen(next);
  };
  const handleControl1 = () => {
    const next = !controlOpen1;
    closeSubControls();
    setControlOpen1(next);
  };
  const handleControl2 = () => {
    const next = !controlOpen2;
    closeSubControls();
    setControlOpen2(next);
  };
  const handleControl3 = () => {
    const next = !controlOpen3;
    closeSubControls();
    setControlOpen3(next);
  };
  const handleControl4 = () => {
    const next = !controlOpen4;
    closeSubControls();
    setControlOpen4(next);
  };
  const handleControl5 = () => {
    const next = !controlOpen5;
    closeSubControls();
    setControlOpen5(next);
  };
  const handleSpace = () => {
    setSpaceOpen(!spaceOpen);
  };
  const handleSchedule = () => {
    setSchOpen(!schOpen);
  };
  const handleAnalytics = () => {
    setAnalytics(!analytics);
  };
  const handleinstrument = () => {
    setInstruments(!instruments);
  };
  // const handleSchedule=()=>{
  //   setSchOpen(!schOpen)
  // }
  const handleReport = () => {
    console.log("resport------>");
    setReportOpen(!reportOpen);
  };

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, logoText, routes } = props;
  var links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        let urlPath = prop.path;
        if (urlPath.indexOf("/:id/") > -1) {
          let splitPaths = urlPath.split("/:id/");
          let assetId = splitPaths[0].includes("building")
            ? localStorage.getItem("buildingID")
            : splitPaths[0].includes("floor")
              ? localStorage.getItem("floorID")
              : splitPaths[0].includes("zone")
                ? localStorage.getItem("zoneID")
                : localStorage.getItem("deviceID");
          urlPath = splitPaths[0] + "/" + assetId + "/" + splitPaths[1];
        }
        var activePro = " ";
        var listItemClasses;
        if (prop.path === "/upgrade-to-pro") {
          activePro = classes.activePro + " ";
          listItemClasses = classNames({
            [" " + classes[color]]: true,
          });
        } else {
          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + urlPath),
          });
        }
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.layout + urlPath),
        });
        return (
          <NavLink
            to={prop.layout + urlPath}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            <ListItem button className={classes.itemLink + listItemClasses}>
              {typeof prop.icon === "string" ? (
                <Icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive,
                  })}
                >
                  {prop.icon}
                </Icon>
              ) : (
                <prop.icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive,
                  })}
                />
              )}
              <ListItemText
                primary={props.rtlActive ? prop.rtlName : prop.name}
                className={classNames(classes.itemText, whiteFontClasses, {
                  [classes.itemTextRTL]: props.rtlActive,
                })}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href="https://graylinx.ai/"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive,
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img
            src={localStorage.getItem("username") == "Guest1" ? simplyIO : logo}
            alt="logo"
            className={classes.img}
          />
        </div>
      </a>
      <IconButton
        onClick={props.handleDrawerClose}
        style={{ zIndex: "4", float: "right", marginTop: "-15%" }}
      >
        <ChevronLeftIcon className={classes.itemIcon} />
      </IconButton>
    </div>
  );
  return (
    <div>
      <Hidden mdUp>
        <Drawer
          className={classes1.drawer}
          variant="persistent"
          anchor="left"
          open={props.open}
          classes={{
            paper: classes1.drawerPaper,
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            <AdminNavbarLinks />
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>

      <Hidden smDown implementation="css">
        <Drawer
          className={classes1.drawer}
          variant="persistent"
          anchor="left"
          open={props.open}
          classes={{
            paper: classes1.drawerPaper,
          }}
        >
          <div
            className={classes.background}
          // style={{ backgroundColor:'#0123B4'}}
          />
          {/* {image !== undefined ? (
          <div
          className={classes.background}
          style={{ backgroundImage: "url(" + image + ")" }}
          />
        ) : null} */}
          {brand}
          <Divider />
          <div className={classes.sidebarWrapper}>
            {/* {links} */}
            <List>
              {localStorage.getItem("roleID") == "6" ? (
                <NavLink
                  to={"/admin/Parkingsolution"}
                  className={" " + classes.item}
                  activeClassName="active"
                >
                  <ListItem
                    button
                    className={
                      classes.itemLink +
                      classNames({
                        [" " + classes[color]]: activeRoute(
                          "/admin/Parkingsolution"
                        ),
                      })
                    }
                  >
                    <BusinessIcon
                      className={
                        classes.itemIcon +
                        classNames({
                          [" " + classes.whiteFont]: activeRoute(
                            "/admin/Parkingsolution"
                          ),
                        })
                      }
                    />

                    <ListItemText
                      primary={"Parking Management"}
                      className={
                        classes.itemText +
                        classNames({
                          [" " + classes.whiteFont]: activeRoute(
                            "/admin/Parkingsolution"
                          ),
                        })
                      }
                      disableTypography={true}
                    />
                  </ListItem>
                </NavLink>
              ) : (
                <>
                  <NavLink
                    to={
                      "/admin/building/" +
                      localStorage.getItem("buildingID") +
                      "/dashboard"
                    }
                    className={" " + classes.item}
                    activeClassName="active"
                    onClick={closeControlDropdown}
                  >
                    <ListItem
                      button
                      className={
                        classes.itemLink +
                        classNames({
                          [" " + classes[color]]: activeRoute(
                            "/admin/building/" +
                            localStorage.getItem("buildingID") +
                            "/dashboard"
                          ),
                        })
                      }
                    >
                      <Home
                        className={
                          classes.itemIcon +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/building/:id/dashboard"
                            ),
                          })
                        }
                      />

                      <ListItemText
                        primary={"Building Dashboard"}
                        className={
                          classes.itemText +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/building/:id/dashboard"
                            ),
                          })
                        }
                        disableTypography={true}
                      />
                    </ListItem>
                  </NavLink>
                  <NavLink
                    to={"/admin/glEnergyMonitoring"}
                    className={" " + classes.item}
                    activeClassName="active"
                    onClick={closeControlDropdown}
                  >
                    <ListItem button className={classes.itemLink}>
                      <EnergySavingsLeafIcon
                        className={
                          classes.itemIcon +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/glEnergyMonitoring"
                            ),
                          })
                        }
                      />

                      <ListItemText
                        primary={"Energy Monitor"}
                        className={
                          classes.itemText +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/glEnergyMonitoring"
                            ),
                          })
                        }
                        disableTypography={true}
                      />
                    </ListItem>
                  </NavLink>
                  <div
                    className={classNames({
                      [" " + classes[color]]: controlOpen,
                    })}
                    style={{ borderRadius: "14px", margin: "5px,5px" }}
                  >
                    <ListItem
                      button
                      className={classes.itemLink}
                      onClick={handleControl}
                    >
                      <BusinessIcon className={classes.itemIcon} />
                      <ListItemText
                        primary={"Building Equipment"}
                        className={
                          classes.itemText +
                          classNames({ [" " + classes.whiteFont]: true })
                        }
                        disableTypography={true}
                      />
                      <ListItemSecondaryAction className={classes.expandIcon}>
                        {controlOpen ? (
                          <ExpandMore onClick={handleControl} />
                        ) : (
                          <ArrowForward
                            className={classes.arrow}
                            onClick={handleControl}
                          />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <div
                          className={classNames({
                            [" " + classes[color]]: controlOpen1,
                          })}
                          style={{
                            borderRadius: "14px",
                            margin: "0px,5px",
                            marginTop: "-20px",
                          }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink}
                            onClick={handleControl1}
                          >
                            <ListItemText
                              primary={"HVAC & Ventilation"}
                              className={
                                classes.itemText +
                                classNames({ [" " + classes.whiteFont]: true })
                              }
                              disableTypography={true}
                              style={{ padding: "0px 2.5em" }}
                            />
                            <ListItemSecondaryAction
                              className={classes.expandIcon}
                            >
                              {controlOpen1 ? (
                                <ExpandMore onClick={handleControl1} />
                              ) : (
                                <ArrowForward
                                  className={classes.arrow}
                                  onClick={handleControl1}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div className={classes.item}>
                            <Collapse
                              in={controlOpen1}
                              timeout="auto"
                              unmountOnExit
                            >
                              {/* <NavLink
                                to={"/admin/GlVRF"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                      classes.sidebarItemBlue]: activeRoute(
                                        "/admin/GlVRF"
                                      ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"VRF"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glAhu"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink> */}
                              <NavLink
                                to={"/admin/gltfa"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/gltfa"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"TFA"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/gltfa"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glahu"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glahu"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"AHU"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glahu"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/GlInlineFan"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/GlInlineFan"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Inline Fan"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glAhu"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glexhaustfan"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glexhaustfan"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Exhaust Fan"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glAhu"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                            </Collapse>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <div
                          className={classNames({
                            [" " + classes[color]]: controlOpen2,
                          })}
                          style={{
                            borderRadius: "14px",
                            margin: "5px,5px",
                            marginTop: "-20px",
                          }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink}
                            onClick={handleControl2}
                          >
                            <ListItemText
                              primary={"Electrical"}
                              className={
                                classes.itemText +
                                classNames({ [" " + classes.whiteFont]: true })
                              }
                              disableTypography={true}
                              style={{ padding: "0px 2.5em" }}
                            />
                            <ListItemSecondaryAction
                              className={classes.expandIcon}
                            >
                              {controlOpen1 ? (
                                <ExpandMore onClick={handleControl2} />
                              ) : (
                                <ArrowForward
                                  className={classes.arrow}
                                  onClick={handleControl2}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div className={classes.item}>
                            <Collapse
                              in={controlOpen2}
                              timeout="auto"
                              unmountOnExit
                            >
                              <NavLink
                                to={"/admin/Transformer"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/Transformer"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Transformer"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/selector"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glDG"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glDG"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"DG"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glsolar"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glsolar"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Solar"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to="/admin/glUPS1"
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    (activeRoute("/admin/glUPS1")  // Check glUPS1 first
                                      ? " " + classes.sidebarItemBlue
                                      : "")
                                  }
                                >
                                  <ListItemText
                                    primary="UPS 6 kVA"
                                    className={
                                      classes.itemText +
                                      (activeRoute("/admin/glUPS1")
                                        ? " " + classes.whiteFont
                                        : "")
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>

                              <NavLink
                                to="/admin/glUPS"
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    // Add condition to exclude glUPS1
                                    (activeRoute("/admin/glUPS") && !window.location.pathname.includes("glUPS1")
                                      ? " " + classes.sidebarItemBlue
                                      : "")
                                  }
                                >
                                  <ListItemText
                                    primary="UPS 20 kVA"
                                    className={
                                      classes.itemText +
                                      (activeRoute("/admin/glUPS") && !window.location.pathname.includes("glUPS1")
                                        ? " " + classes.whiteFont
                                        : "")
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glsuppression"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glsuppression"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Suppression System"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glfirealarm"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glfirealarm"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Fire Alarm"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                            </Collapse>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <div
                          className={classNames({
                            [" " + classes[color]]: controlOpen3,
                          })}
                          style={{
                            borderRadius: "14px",
                            margin: "5px,5px",
                            marginTop: "-20px",
                          }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink}
                            onClick={handleControl3}
                          >
                            <ListItemText
                              primary={"Pumps"}
                              className={
                                classes.itemText +
                                classNames({ [" " + classes.whiteFont]: true })
                              }
                              disableTypography={true}
                              style={{ padding: "0px 2.5em" }}
                            />
                            <ListItemSecondaryAction
                              className={classes.expandIcon}
                            >
                              {controlOpen1 ? (
                                <ExpandMore onClick={handleControl3} />
                              ) : (
                                <ArrowForward
                                  className={classes.arrow}
                                  onClick={handleControl3}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div className={classes.item}>
                            <Collapse
                              in={controlOpen3}
                              timeout="auto"
                              unmountOnExit
                            >
                              {/* <NavLink
                                to={"/admin/GlPlumbingPump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                      classes.sidebarItemBlue]: activeRoute(
                                        "/admin/GlPlumbingPump"
                                      ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Plumbing Water Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/GlPlumbingPump"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink> */}
                              {/* <NavLink
                                to={"/admin/glDomesticWaterPump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                      classes.sidebarItemBlue]: activeRoute(
                                        "/admin/glDomesticWaterPump"
                                      ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Domestic Water Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink> */}
                              <NavLink
                                to={"/admin/glsumppump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glsumppump"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Sump Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glsewagepump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glsewagepump"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Sewage  Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glwaterpump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glwaterpump"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Water  Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>

                              <NavLink
                                to={"/admin/glhpp"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glhpp"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Hydro Pneumatic Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glhprwp"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glhprwp"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Hydro Pneumatic Raw Water Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>

                              {/* <NavLink
                                to={"/admin/glwatertank"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                      classes.sidebarItemBlue]: activeRoute(
                                        "/admin/glwatertank"
                                      ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Tank Level"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink> */}
                              <NavLink
                                to={"/admin/glwatertanklevel"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glwatertanklevel"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Water Tank "}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glVav"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                              <NavLink
                                to={"/admin/glfirefightingpump"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glfirefightingpump"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Fire Fighting Pump"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glfirefightingpump"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                            </Collapse>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <div
                          className={classNames({
                            [" " + classes[color]]: controlOpen4,
                          })}
                          style={{
                            borderRadius: "14px",
                            margin: "5px,5px",
                            marginTop: "-20px",
                          }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink}
                            onClick={handleControl4}
                          >
                            <ListItemText
                              primary={"Lifts"}
                              className={
                                classes.itemText +
                                classNames({ [" " + classes.whiteFont]: true })
                              }
                              disableTypography={true}
                              style={{ padding: "0px 2.5em" }}
                            />
                            <ListItemSecondaryAction
                              className={classes.expandIcon}
                            >
                              {controlOpen1 ? (
                                <ExpandMore onClick={handleControl4} />
                              ) : (
                                <ArrowForward
                                  className={classes.arrow}
                                  onClick={handleControl4}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div className={classes.item}>
                            <Collapse
                              in={controlOpen4}
                              timeout="auto"
                              unmountOnExit
                            >
                              {/* <NavLink
                                to={"/admin/glLift"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                      classes.sidebarItemBlue]: activeRoute(
                                        "/admin/glLift"
                                      ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Lift"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glLift"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink> */}
                              <NavLink
                                to={"/admin/glScooterLift"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glScooterLift"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"Scooter Lift & Passenger Lift"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glScooterLift"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>
                            </Collapse>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <div
                          className={classNames({
                            [" " + classes[color]]: controlOpen5,
                          })}
                          style={{
                            borderRadius: "14px",
                            margin: "5px,5px",
                            marginTop: "-20px",
                          }}
                        >
                          <ListItem
                            button
                            className={classes.itemLink}
                            onClick={handleControl5}
                          >
                            <ListItemText
                              primary={"Water Treatment"}
                              className={
                                classes.itemText +
                                classNames({ [" " + classes.whiteFont]: true })
                              }
                              disableTypography={true}
                              style={{ padding: "0px 2.5em" }}
                            />
                            <ListItemSecondaryAction
                              className={classes.expandIcon}
                            >
                              {controlOpen1 ? (
                                <ExpandMore onClick={handleControl5} />
                              ) : (
                                <ArrowForward
                                  className={classes.arrow}
                                  onClick={handleControl5}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div className={classes.item}>
                            <Collapse
                              in={controlOpen5}
                              timeout="auto"
                              unmountOnExit
                            >
                              <NavLink
                                to={"/admin/glROPlant"}
                                className={" " + classes.item}
                                activeClassName="active"
                              >
                                <ListItem
                                  button
                                  className={
                                    classes.divItemLink +
                                    classNames({
                                      [" " +
                                        classes.sidebarItemBlue]: activeRoute(
                                          "/admin/glROPlant"
                                        ),
                                    })
                                  }
                                >
                                  <ListItemText
                                    primary={"RO Plant"}
                                    className={
                                      classes.itemText +
                                      classNames({
                                        [" " + classes.whiteFont]: activeRoute(
                                          "/admin/glROPlant"
                                        ),
                                      })
                                    }
                                    disableTypography={true}
                                    style={{ padding: "0px 2.5em" }}
                                  />
                                </ListItem>
                              </NavLink>

                            </Collapse>
                          </div>
                        </div>
                      </Collapse>

                    </div>
                    <div className={classes.item}>
                      <Collapse in={controlOpen} timeout="auto" unmountOnExit>
                        <NavLink
                          to={"/admin/glwld"}
                          className={" " + classes.item}
                          activeClassName="active"
                        >
                          <ListItem
                            button
                            className={
                              classes.divItemLink +
                              classNames({
                                [" " +
                                  classes.sidebarItemBlue]: activeRoute(
                                    "/admin/glwld"
                                  ),
                              })
                            }
                          >
                            <ListItemText
                              primary={"WLD"}
                              className={
                                classes.itemText +
                                classNames({
                                  [" " + classes.whiteFont]: activeRoute(
                                    "/admin/glwld"
                                  ),
                                })
                              }
                              disableTypography={true}
                            //style={{ padding: "0px 2.5em" }}
                            />
                          </ListItem>
                        </NavLink>
                      </Collapse>
                    </div>

                  </div>


                  {/* <NavLink
                    to={"/admin/PlantRoomEnergyAnalytics"}
                    className={" " + classes.item}
                    activeClassName="active"
                  >
                    <ListItem button className={classes.itemLink}>
                      <AssessmentIcon
                        className={
                          classes.itemIcon +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/PlantRoomEnergyAnalytics"
                            ),
                          })
                        }
                      />

                      <ListItemText
                        primary={"Energy Monitoring"}
                        className={
                          classes.itemText +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/PlantRoomEnergyAnalytics"
                            ),
                          })
                        }
                        disableTypography={true}
                      />
                    </ListItem>
                  </NavLink> */}

                  <NavLink
                    to={"/admin/glEMLandingPage"}
                    className={" " + classes.item}
                    activeClassName="active"
                    onClick={closeControlDropdown}
                  >
                    <ListItem
                      button
                      className={
                        classes.itemLink +
                        classNames({
                          [" " + classes[color]]: activeRoute(
                            "/admin/glEMLandingPage",
                          ),
                        })
                      }
                    >
                      <AssessmentIcon
                        className={
                          classes.itemIcon +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/glEMLandingPage",
                            ),
                          })
                        }
                      />
                      <ListItemText
                        primary={"Energy Meter"}
                        className={
                          classes.itemText +
                          classNames({
                            [" " + classes.whiteFont]: activeRoute(
                              "/admin/glEMLandingPage",
                            ),
                          })
                        }
                        disableTypography={true}
                      />
                    </ListItem>
                  </NavLink>
                  {
                    role_id != 2 ? (
                      <div
                        className={classNames({
                          [" " + classes[color]]: reportOpen,
                        })}
                        style={{
                          borderRadius: "14px",
                          margin: "5px,5px",
                          pointerEvents: "none",
                          opacity: "0.4",
                        }}
                      >
                        <NavLink
                          to={"/admin/reportsviewer"}
                          className={" " + classes.item}
                          activeClassName="active"
                          onClick={closeControlDropdown}
                        >
                          <ListItem
                            button
                            className={
                              classes.itemLink +
                              classNames({
                                [" " + classes[color]]: activeRoute(
                                  "/admin/reportsviewer"
                                ),
                              })
                            }
                          >
                            <DescriptionIcon
                              className={
                                classes.itemIcon +
                                classNames({
                                  [" " + classes.whiteFont]: activeRoute(
                                    "/admin/reportsviewer"
                                  ),
                                })
                              }
                            />

                            <ListItemText
                              primary={"Report"}
                              className={
                                classes.itemText +
                                classNames({
                                  [" " + classes.whiteFont]: activeRoute(
                                    "/admin/reportsviewer"
                                  ),
                                })
                              }
                              disableTypography={true}
                            />
                          </ListItem>
                        </NavLink>
                      </div>
                    ) : (
                      <NavLink
                        to={"/admin/reportsviewer"}
                        className={" " + classes.item}
                        activeClassName="active"
                        onClick={closeControlDropdown}
                      >
                        <ListItem
                          button
                          className={
                            classes.itemLink +
                            classNames({
                              [" " + classes[color]]: activeRoute(
                                "/admin/reportsviewer"
                              ),
                            })
                          }
                        >
                          <DescriptionIcon
                            className={
                              classes.itemIcon +
                              classNames({
                                [" " + classes.whiteFont]: activeRoute(
                                  "/admin/reportsviewer"
                                ),
                              })
                            }
                          />

                          <ListItemText
                            primary={"Report"}
                            className={
                              classes.itemText +
                              classNames({
                                [" " + classes.whiteFont]: activeRoute(
                                  "/admin/reportsviewer"
                                ),
                              })
                            }
                            disableTypography={true}
                          />
                        </ListItem>
                      </NavLink>
                    )
                    //  <div className={classNames({[" " + classes[color]]: reportOpen})}  style={{borderRadius: '14px',margin:'5px,5px'}}>
                    //     <ListItem button className={classes.itemLink} onClick={handleReport} >
                    //       <AssessmentIcon   className={classes.itemIcon}/>
                    //       <ListItemText
                    //         primary={'Reports'}
                    //         className={classes.itemText + classNames({ [" " + classes.whiteFont]: true })}
                    //         disableTypography={true}
                    //       />
                    //        <ListItemSecondaryAction className={classes.expandIcon} >
                    //        {reportOpen ? <ExpandMore
                    //           onClick={handleReport} /> : <ArrowForward  className={classes.arrow} onClick={handleReport} />}
                    //         </ListItemSecondaryAction>
                    //      </ListItem>
                    //      <div className={classes.item} >
                    //      <Collapse in={reportOpen} timeout="auto" unmountOnExit >
                    //        <NavLink to={'/admin/reportsviewer'} className={" " + classes.item} activeClassName="active">
                    //            <ListItem button className={classes.divItemLink + classNames({
                    //                     [" " + classes.sidebarItemBlue]: activeRoute('/admin/reportsviewer')
                    //                     })}>
                    //            {/* <BusinessIcon
                    //                   className={classes.itemIcon + classNames({ [" " + classes.whiteFont]: activeRoute('/admin/reportsviewer') })}
                    //                /> */}
                    //            <ListItemText
                    //                primary={'Report'}
                    //                className={classes.itemText + classNames({ [" " + classes.whiteFont]: activeRoute('/admin/reportsviewer') })}
                    //                disableTypography={true}
                    //              />
                    //            </ListItem>
                    //        </NavLink>
                    //      </Collapse>
                    //      </div>
                    //  </div>
                  }

                  {/* <NavLink
                to={'/admin/Glschedule'}
                className={" " + classes.item}
                activeClassName="active"
              >
                <ListItem button className={classes.itemLink + classNames({
                  [" " + classes[color]]: activeRoute('/admin/Glschedule')
                })}>

                  <CalendarTodayIcon
                    className={classes.itemIcon + classNames({ [" " + classes.whiteFont]: activeRoute('/admin/Glschedule') })}
                  />

                  <ListItemText
                    primary={'Scheduler'}
                    className={classes.itemText + classNames({ [" " + classes.whiteFont]: activeRoute('/admin/Glschedule') })}
                    disableTypography={true}
                  /> 
                </ListItem>
              </NavLink>  */}
                </>
              )}
            </List>
          </div>
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf([
    "purple",
    "blue",
    "green",
    "orange",
    "red",
    "info",
  ]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
